import unreleaseTripMessagesModule from "./unreleaseTripMessagesModule"
import unreleaseTripMessagesView from "./unreleaseTripMessagesView.html"

unreleaseTripMessagesModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.unreleaseTripMessages", {
        data: {
            pageTitle: "{{'title.r2.unreleaseTripMessages' | translate}}",
            group: "group.r2.integration.unrelease.trip.messages"
        },
        template: unreleaseTripMessagesView,
        url: "/integration/unrelease-trip",
        controller: "unreleaseTripMessagesController"
    })
}])